export default [
    {
        title: 'روند ها',
        icon: 'MailIcon',
        children: [
            {
                title: 'لیست روند ها',
                icon: 'InboxIcon',
                route: 'Processes_Inbox',
                permission: 'processes.index',
            },
            {
                title: 'روند جدید',
                icon: 'Edit3Icon',
                route: 'Processes_Create',
                permission: 'processes.store',

            },
        ]
    }
]
